export function formatMilliSeconds(value: number) {
    if (value === 0) {
        return '0s';
    }

    value = Math.round(Number(value) / 1000);
    const h = Math.floor(value / 3600);
    const m = Math.floor((value % 3600) / 60);
    const s = Math.floor((value % 3600) % 60);

    const hDisplay = h > 0 ? h + (m > 0 || s > 0 ? 'h ' : 'h') : '';
    const mDisplay = m > 0 ? m + (s > 0 ? 'min ' : 'min') : '';
    const sDisplay = s > 0 ? s + 's' : '';
    return hDisplay + mDisplay + sDisplay;
}

export function formatMilliSecondsWithDecimals(ms: number): string {
    if (!ms) return '0s';

    const totalSeconds = ms / 1000;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [
        hours ? `${hours}h` : '',
        minutes ? `${minutes}min` : '',
        seconds ? `${Number(seconds.toFixed(2))}s` : ''
    ];

    return parts.filter(Boolean).join(' ');
}

export function formatSeconds(value: number) {
    if (value === 0) {
        return '0s';
    }

    const h = Math.floor(value / 3600);
    const m = Math.floor((value % 3600) / 60);
    const s = Math.floor((value % 3600) % 60);

    const hDisplay = h > 0 ? h + (m > 0 || s > 0 ? 'h ' : 'h') : '';
    const mDisplay = m > 0 ? m + (s > 0 ? 'min ' : 'min') : '';
    const sDisplay = s > 0 ? s + 's' : '';
    return hDisplay + mDisplay + sDisplay;
}
